import { HttpHelper, HttpServiceParams } from '@ppvrbh/merchant-frontend-core';
import { envConfig } from '../../../../config';
import { INVITATION_REQUEST_ID_LIST } from './invitation-constant';

class InvitationServiceClass {
  postInvitationRegistration = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: `${envConfig.hostname}v1/merchant/company-admin/merchant-gp-acceptance`,
      data: params.data,
      id: INVITATION_REQUEST_ID_LIST.POST_INVITATION_REGISTRATION
    });
  }
  
  getTncStatus = async (params: HttpServiceParams) => {
    const searchParams = new URLSearchParams();
    const {token, channel} = params.data;
    let shouldAppend = false;
    
    if (token) {
      searchParams.append('token', token)
      shouldAppend = true;
    }
    if (channel) {
      searchParams.append('channel', channel)
      shouldAppend = true;
    }

    let query = '';
    if (shouldAppend) {
      query = '?' + searchParams.toString();
    }
  
    return await HttpHelper.get({
      url: `${envConfig.hostname}v1/merchant/company-admin/merchant-gp-acceptance` + query,
      id: INVITATION_REQUEST_ID_LIST.GET_TNC_STATUS
    });
  }

  getTncDetail = async (params: HttpServiceParams) => { 
    return await HttpHelper.get({
      url: params.data.url,
      id: INVITATION_REQUEST_ID_LIST.GET_TNC_DETAIL
    });
  }
}

export const InvitationService = new InvitationServiceClass();
